import React, { FC } from "react";
import { Button, Container, Grid, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import BathtubIcon from "@mui/icons-material/Bathtub";
import { ChevronLeft } from "@mui/icons-material";
import StickyHeader from "./StickyHeader";

/**
 * The Error page we use with react-router.
 */
const Error: FC = () => {
  const navigate = useNavigate();
  return (
    <Container maxWidth={false} style={{ height: "100vh" }} disableGutters>
      <StickyHeader />
      <Grid
        container
        direction="column"
        height="calc(100vh - 110px)"
        alignItems="center"
        justifyContent="center"
        spacing={0}
        gap="25px"
      >
        <Grid item>
          <BathtubIcon fontSize="large" style={{ transform: "scale(2.8)" }} />
        </Grid>
        <Grid item>
          <Typography variant="h6" align="center">
            Hoppla. Diese Seite sollten Sie nicht sehen.{" "}
          </Typography>
        </Grid>
        <Grid item>
          <Button
            onClick={() => {
              navigate(-1);
            }}
            startIcon={<ChevronLeft />}
          >
            Zurück
          </Button>
        </Grid>
      </Grid>
    </Container>
  );
};

export default Error;
